exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sso{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);text-align:center}.sso-header{font-family:Roboto;font-size:32px;font-weight:700;line-height:37.5px}.sso-description{font-family:Roboto;font-size:16px;font-weight:400;line-height:18.75px}.sso-error{color:#e30909}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};